import type { ReactNode } from "react"

/* Wraps routed page content so it gently fades + lifts in on mount.
 * Pure CSS (see .animate-page-enter in design-system.css) — no deps. */
export function PageTransition({ children }: { children: ReactNode }) {
  return <div className="animate-page-enter">{children}</div>
}
